module.exports = __webpack_public_path__ + "img/yinjiang.b4dc8f2f.png";